/* eslint import/prefer-default-export: "off" */
import type { ChangeInfo } from '@src/endpoints/services/changeMgr.service'
import type { ChangeItem } from '@src/redux/reducers/changes'
import type { CommonTypeCount } from '@src/endpoints/services/commonHdr.service'
import { sortByField } from './array.utils'
import { getAccountNameById } from './accounts'
import type { AccountInfo } from '@src/endpoints/services/base.service'

export const parsedChangesList = (
  change_info_list: ChangeInfo[] = [],
  accountInfo: AccountInfo[]
): ChangeItem[] =>
  (change_info_list || []).map(item => {
    const changeInfo: ChangeItem = {
      ...item,
      identity_account_name: getAccountNameById(
        item.from_account_id,
        accountInfo || []
      )
    }
    if (
      typeof item.source_type !== 'undefined' &&
      Array.isArray(item.source_type)
    ) {
      changeInfo.type = item.source_type.join(', ')
    }
    return changeInfo
  })

export const sortByType = (countList: CommonTypeCount[]) =>
  sortByField(countList, 'type', (x: any, y: any) => {
    if (x.type === 'All') return -1
    if (y.type === 'All') return 1
    return 0
  })
